










































































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Planning extends Vue {
    // @Prop() private title!: string;
}
